import { Common, ApiBind } from './common.model';

export class DeliverySetPlacement extends Common {
  @ApiBind({ column: 'text_target' })
  textTarget: string;
}
